// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"d66e57fd","365":"0dcf4676","402":"9f3b8d53","643":"d297b0f4","734":"a484f421"}[chunkId] + ".chunk.js";
};